import { FormattedMessage } from 'react-intl';

import { ConnectCalendarAccountButton } from 'app/src/components/Planner/ConnectCalendarAccountButton/ConnectCalendarAccountButton';
import { SmartScheduleOnboardingImage } from './SmartScheduleOnboardingImage';

import * as styles from './ConnectAccount.module.less';

/**
 * Onboarding step that prompts the member to connect a calendar account. Calls
 * `onConnected` after a successful connect.
 */
export const ConnectAccount = ({
  onConnected,
}: {
  onConnected: () => void;
}) => {
  return (
    <div className={styles.container}>
      <h2>
        <FormattedMessage
          id="templates.smart_schedule.onboarding.connect-heading"
          defaultMessage="Connect an account to start scheduling"
          description="Heading on the connect-account onboarding page"
        />
      </h2>
      <p className={styles.subtext}>
        <FormattedMessage
          id="templates.smart_schedule.onboarding.connect-subtext"
          defaultMessage="Focus time suggestions need a connected calendar account to schedule any cards."
          description="Subtext explaining why a connected calendar account is required"
        />
      </p>
      <ConnectCalendarAccountButton
        onAfterAuth={onConnected}
        analyticsSource="smartScheduleOnboardingModal"
        popoverPlacement="bottom"
      />
      <SmartScheduleOnboardingImage />
    </div>
  );
};
